import { isDarkModeAtom, themeAtom } from "../shared/atoms";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

export function ThemeEffect({ useTailwindDark = false }: { useTailwindDark?: boolean }) {
  const isDarkMode = useAtomValue(isDarkModeAtom);
  const theme = useAtomValue(themeAtom);

  useEffect(() => {
    const root = document.documentElement;

    root.dataset.theme = isDarkMode ? "dark" : "light";

    if (useTailwindDark) {
      root.classList.toggle("dark", isDarkMode);
    }

    const vars: Record<string, string> = {
      // Home
      "--home-bg": theme.home.tailwind.backgound,
      "--home-panel-bg": theme.home.tailwind.panelBackground,
      "--home-text-default": theme.home.tailwind.textDefault,
      "--home-text-secondary": theme.uwhcAssistant.text,

      // Header
      "--header-dot-active": theme.headerComponent.inline.dotActive,
      "--header-dot-inactive": theme.headerComponent.inline.dotInactive,
      "--header-tooltip-bg": theme.headerComponent.inline.tooltipBackground,
      "--header-tooltip-text": theme.headerComponent.inline.tooltipText,

      // React Calendar
      "--calendar-bg": theme.balticQuestionnaire.reactDatePicker.background,
      "--calendar-border": theme.balticQuestionnaire.reactDatePicker.border,
      "--selected-day-bg": theme.balticQuestionnaire.reactDatePicker.selectedDayBg,
      "--day-hover-bg": theme.balticQuestionnaire.reactDatePicker.dayHover,
      "--calendar-input-bg": theme.balticQuestionnaire.reactDatePicker.inputBg,
      "--calendar-input-border": theme.balticQuestionnaire.reactDatePicker.inputBorder,
      "--calendar-input-text": theme.technicalQuestionnaire.reactInputText,
    };

    for (const [k, v] of Object.entries(vars)) {
      root.style.setProperty(k, v);
    }
  }, [isDarkMode, theme, useTailwindDark]);

  return null;
}
